module.exports = "query CurrentAssetsVersionQuery{currentAssetsVersion}"